import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

export const initialValue: { locations: any[] } = {
  locations: [],
};

export const MobileHeartBeatStore = signalStore(
  { providedIn: 'root' },
  withState(initialValue),
  withMethods(({ ...store }) => ({
    setLocations(locations: any[]) {
      patchState(store, { locations });
      sessionStorage.setItem('locations', JSON.stringify(locations));
    },
  })),
);
